import { environment } from '../../../environments/environment';

/** Regular expression to validate the format of an email address. */
export const EMAIL_REGEXP = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

/** Map of sid → service name, as defined in the environment configuration. */
export const SERVICES = environment.services;

/** Map of service name → sid, as defined in the environment configuration. */
export const APPS = environment.sids;
